import axios from 'axios';
import { log } from './logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const sendChat = async (sessionId, message) => {
  const r = await axios.post(`${API}/chat`, { session_id: sessionId, message });
  return r.data;
};

export const createLead = async (payload) => {
  const r = await axios.post(`${API}/leads`, payload);
  return r.data;
};

// ---------- Admin ----------
// Admin token lives in sessionStorage so it clears when the tab closes.
// This is a defense-in-depth measure vs localStorage; still susceptible to XSS,
// but reduces the attack window dramatically for admin sessions.
const ADMIN_TOKEN_KEY = 'ukk_admin_token';

export const adminLogin = async (password) => {
  const r = await axios.post(`${API}/admin/login`, { password });
  try { sessionStorage.setItem(ADMIN_TOKEN_KEY, r.data.token); } catch (e) { log.warn('Failed to persist admin token', e); }
  return r.data;
};

export const getAdminToken = () => {
  try { return sessionStorage.getItem(ADMIN_TOKEN_KEY); } catch (e) { log.warn('Failed to read admin token', e); return null; }
};

export const adminLogout = () => {
  try { sessionStorage.removeItem(ADMIN_TOKEN_KEY); } catch (e) { log.warn('Failed to clear admin token', e); }
};

const adminHeaders = () => ({ Authorization: `Bearer ${getAdminToken()}` });

export const fetchAdminDashboard = async (period = 'week') => {
  const r = await axios.get(`${API}/admin/dashboard?period=${period}`, { headers: adminHeaders() });
  return r.data;
};

export const fetchAdminChats = async (limit = 50) => {
  const r = await axios.get(`${API}/admin/chats?limit=${limit}`, { headers: adminHeaders() });
  return r.data;
};

export const fetchAdminChatTranscript = async (sessionId) => {
  const r = await axios.get(`${API}/admin/chat/${sessionId}`, { headers: adminHeaders() });
  return r.data;
};

export const fetchAdminLeads = async (limit = 500) => {
  const r = await axios.get(`${API}/admin/leads?limit=${limit}`, { headers: adminHeaders() });
  return r.data;
};
